export type TargetStatus = 'pending' | 'running' | 'success' | 'failed';

export type ProgressEvent =
  | { type: 'target-start'; target: string; targetDb?: string }
  | { type: 'statement-start'; target: string; targetDb?: string; index: number }
  | { type: 'target-success'; target: string; targetDb?: string }
  | { type: 'target-failed'; target: string; targetDb?: string; error: string }
  | { type: 'run-complete'; status: 'success' | 'failed' };

export interface ProgressState {
  status: Record<string, TargetStatus>;
  currentStatement: Record<string, number>;
  errorByTarget: Record<string, string>;
  succeededTargets: string[];
  failedTarget?: string;
  errorMessage?: string;
  complete: null | { status: 'success' | 'failed' };
}

export function initialState(targets: string[]): ProgressState {
  return {
    status: Object.fromEntries(targets.map((t) => [t, 'pending'])),
    currentStatement: {},
    errorByTarget: {},
    succeededTargets: [],
    failedTarget: undefined,
    errorMessage: undefined,
    complete: null,
  };
}

export function progressReducer(state: ProgressState, evt: ProgressEvent): ProgressState {
  switch (evt.type) {
    case 'target-start':
      return { ...state, status: { ...state.status, [evt.target]: 'running' } };
    case 'statement-start':
      return { ...state, currentStatement: { ...state.currentStatement, [evt.target]: evt.index } };
    case 'target-success':
      return {
        ...state,
        status: { ...state.status, [evt.target]: 'success' },
        succeededTargets: state.succeededTargets.includes(evt.target)
          ? state.succeededTargets
          : [...state.succeededTargets, evt.target],
      };
    case 'target-failed':
      return {
        ...state,
        status: { ...state.status, [evt.target]: 'failed' },
        errorByTarget: { ...state.errorByTarget, [evt.target]: evt.error },
        failedTarget: state.failedTarget ?? evt.target,
        errorMessage: state.errorMessage ?? evt.error,
      };
    case 'run-complete':
      return { ...state, complete: { status: evt.status } };
    default:
      return state;
  }
}
